import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'rpe-nsp2p1',
  templateUrl: './rpe-nsp2p1.component.html',
  styleUrl: './rpe-nsp2p1.component.scss'
})
export class RpeNsp2p1Component {

}
